export const AGENTIC_WORKERS_MESSAGE = {
	BUTTON_WORKING: 'agentic_workers.button.working',
	BUTTON_STOP: 'agentic_workers.button.stop',
	BUTTON_WORKING_NAME: 'agentic_workers.button.working_name',
	MENU_RUN: 'agentic_workers.menu.run',
	MENU_RUNNING: 'agentic_workers.menu.running',
	MENU_SCHEDULE: 'agentic_workers.menu.schedule',
	MENU_PAST_RUNS: 'agentic_workers.menu.past_runs',
	BADGE_WAITING: 'agentic_workers.badge.waiting',
	TOAST_RUN_STOPPED: 'agentic_workers.toast.run_stopped',
	ROW_ACTION_WORKING: 'agentic_workers.row_action.working',
	ROW_ACTION_READY: 'agentic_workers.row_action.ready',
	ROW_ACTION_STOP: 'agentic_workers.row_action.stop',
	ROW_ACTION_STOP_PAGE_RUN: 'agentic_workers.row_action.stop_page_run',
	ROW_ACTION_READY_MENU: 'agentic_workers.row_action.ready_menu',
} as const;
